export default {
	termsAndConditions: {
		lastUpdate: 'Kemas kini terakhir: 10 Jun 2024',
		content: `
		<p>Syarat yang anda akan dapati di bawah adalah penting kerana:</p>
		<ul>
			<li>Mereka mewujudkan hak undang-undang mereka dalam {siteName}.</li>
			<li>Terangkan hak yang anda berikan kepada kami apabila anda menggunakan {siteName}.</li>
			<li>
				Mereka menerangkan peraturan yang mesti dipatuhi oleh semua orang apabila menggunakan {siteName}.
			</li>
		</ul>
		<p>
			Sila baca Syarat ini dengan teliti, serta {privacyPolicyLink} kami dan mana-mana yang lain
			dokumen yang disebut dalam Terma ini.
		</p>
		<p>Mari mulakan...</p>
		<h3>1. PENGENALAN DAN DATA {siteNameUpper}.</h3>
		<p>
			Tapak web {websiteLink} (selepas ini, "Laman Web") dimiliki oleh syarikat
			{siteName} S.L (selepas ini, "{siteName}"), Sebuah syarikat
			diperbadankan mengikut perundangan Sepanyol dengan alamat di Avenida de
			Cerdanyola, no 75, 1º, Sant Cugat del Vallès (Barcelona), pemegang nombor CIF
			B-56.768.260 dan didaftarkan dalam Mercantile Registry Barcelona dalam Jilid
			49065, Folio 0033, Helaian B-606324, Pendaftaran Pertama.
		</p>
		<p>
			{siteName} meletakkan Tapak Web sebagai kemudahan anda supaya anda boleh sampai ke
			mengenali kami dengan lebih baik, mengetahui perkhidmatan yang kami sediakan dan jika anda mahu, anda boleh menghubungi
			dan, jika sesuai, kontrak dengan kami.
		</p>
		<h3>2. TUJUAN DAN SKOP PEMAKAIAN TERMA PENGGUNAAN</h3>
		<p>
			Syarat penggunaan ini membentuk, bersama-sama dengan {privacyPolicyLink} dan
			{cookiesPolicyLink}, rangka kerja undang-undang yang mengawal penggunaan tapak web
			{websiteLink}. Syarat penggunaan ini akan tersedia untuk anda di tapak web
			dalam bahasa inggeris supaya anda boleh merujuk, mengarkib atau mencetaknya pada bila-bila masa dan
			bila-bila masa anda mahu.
		</p>
		<p>
			Untuk mengetahui sebarang soalan mengenai rawatan yang dijalankan oleh {siteName}.
			data peribadi anda, sila lawati {privacyPolicyLink} kami dan {cookiesPolicyLink} kami.
			Kedua-dua dasar juga akan tersedia untuk anda dalam bahasa Inggeris supaya anda boleh
			rujuk, arkib atau cetaknya pada bila-bila masa.<br />
			{siteName} menggunakan kuki pihak ketiga di Laman Web. Untuk mengetahui lebih lanjut
			tentang jenis kuki yang digunakan di web {websiteLink}, tujuannya dan caranya
			untuk mengkonfigurasi pelayar anda sekiranya anda tidak mahu kami menggunakan kuki ini,
			sila lawati {cookiesPolicyLink} kami.
		</p>
		<p>
			Kedua-dua syarat penggunaan ini, serta {privacyPolicyLink} dan 
			{cookiesPolicyLink} telah disediakan mengikut peruntukan semasa
			peraturan yang terpakai, antara lain, Undang-undang 34/2002, tentang Perkhidmatan
			Masyarakat Maklumat dan Perdagangan dan Peraturan Elektronik (EU) 2016/679 daripada
			Parlimen Eropah dan Majlis, pada 27 April 2016, mengenai
			perlindungan orang asli berkenaan dengan pemprosesan peribadi
			data dan peredaran bebas data ini dan melaluinya Arahan 95/46 / CE
			dimansuhkan.
		</p>
		<h3>3. AKSES KE LAMAN WEB DAN PENERIMAAN</h3>
		<p>
			Akses ke Laman Web adalah percuma kecuali bahagian yang berkaitan dengan kos
			sambungan melalui rangkaian telekomunikasi yang disediakan oleh Internet
			pembekal akses yang telah anda kontrak. Anda boleh melayari Laman Web dengan bebas
			dan aksesnya seberapa banyak yang anda mahu. Untuk mengakses dan menavigasi Laman Web,
			anda tidak perlu mendaftar, kecuali jika anda ingin mengupah perkhidmatan.
		</p>
		<p>
			Penggunaan laman web memberikan anda keadaan pengguna laman web tersebut
			(selepas ini, "Pengguna") dan membayangkan penerimaan penuh dan tanpa syarat anda terhadap
			syarat penggunaan ini, serta {privacyPolicyLink} dan {cookiesPolicyLink}
			daripada Laman Web. Tambahan pula, anda bersetuju untuk tidak menggunakan Perkhidmatan untuk menyalahi undang-undang
			tujuan.
		</p>
		<p>
			Dengan mengakses Laman Web dan menyemak imbasnya, anda mengisytiharkan di bawah anda
			tanggungjawab bahawa anda sudah mencapai umur yang sah dan anda mempunyai undang-undang yang diperlukan
			keupayaan untuk mengakses Laman Web dan menggunakannya, juga mengisytiharkan bahawa anda sepenuhnya
			memahami dan menerima syarat penggunaan ini tanpa sebarang tempahan.
		</p>
		<p>
			Sebaliknya, kami memaklumkan anda bahawa atas sebab undang-undang kami mengarkibkan
			dokumen elektronik di mana pembelian diformalkan. Anda boleh mengakses
			dokumen ini pada bila-bila masa dengan memintanya di: {supportLink}.
		</p>
		<h3>4. SYARAT PENGGUNAAN LAMAN WEB</h3>
		<p>
			Pengguna bersetuju untuk menggunakan Laman Web selaras dengan syarat penggunaan ini,
			perundangan semasa dan niat baik. Oleh itu, Pengguna akan bertindak balas kepada {siteName}.
			 dan di hadapan mana-mana pihak ketiga untuk kerosakan dan kerugian yang diperoleh daripada
			penggunaan yang bertentangan dengan syarat ini, perundangan dan niat baik yang dibuat
			oleh Pengguna Laman Web.
		</p>
		<h3>5. PENERANGAN PERKHIDMATAN</h3>
		<p>
			Melalui Perkhidmatan, {siteName} membenarkan langganan perkhidmatan kepada
			menjalankan penyuntingan imej.
		</p>
		<p>
			Bahasa di mana kontrak antara {siteName} dan pembeli
			akan disimpulkan ialah negara asal.<br />
			Proses pembelian dalam perkhidmatan dalam talian adalah seperti berikut:
		</p>
		<ol>
			<li>Anda mesti mendaftar di tapak web dengan nama pengguna dan kata laluan.</li>
			<li>
				Pada masa pendaftaran, pengguna mesti memilih salah satu pelan pembayaran
				terdapat dalam bahagian Harga dan akan diberikan kredit bergantung pada
				rancangan yang dipilih. Setiap kredit akan membolehkan anda mengedit satu imej.
			</li>
			<li>
				Selepas pembelian perkhidmatan, pengguna akan mempunyai pentadbiran
				panel di mana mereka akan dapati:
				<ul>
					<li>
						Bahagian dengan senarai semua imej yang telah diproses, sedang
						boleh mengeditnya seberapa banyak yang anda mahu dan memuat turunnya ke anda
						peranti.
					</li>
					<li>
						Bahagian Pelan dan pembayaran untuk merujuk invois dan membatalkan
						langganan.
					</li>
					<li>Bahagian Akaun Saya untuk dapat menukar pilihan akaun.</li>
				</ul>
			</li>
		</ol>
		<p>
			Setelah pembelian perkhidmatan telah dibuat, ia akan disahkan oleh
			menghantar e-mel, dalam tempoh maksimum 24 jam, ke alamat yang anda miliki
			ditunjukkan. Ia akan menunjukkan perkhidmatan, bagaimana untuk membatalkan langganan, itu
			amaun, cukai terpakai, bentuk pembayaran dan terma terpakai dan
			syarat.
		</p>
		<h4>5.1 Langganan</h4>
		<p>
			Langganan perkhidmatan berbeza-beza bergantung pada pelan yang dipilih dan akan
			diperbaharui secara automatik untuk tempoh masa yang sama sehingga penamatannya.
			Melainkan anda membatalkan langganan anda, anda memberi kebenaran kepada kami untuk memuatkan
			yuran langganan tahunan yang sepadan dalam kaedah pembayaran anda.
		</p>
		<p>
			Anda boleh membatalkan langganan Perkhidmatan anda pada bila-bila masa, dan anda akan melakukannya
			terus mempunyai akses kepadanya sehingga akhir tempoh pengebilan tahunan anda. Kepada
			setakat yang dibenarkan oleh undang-undang, bayaran tidak boleh dikembalikan dan kami tidak menyediakannya
			bayaran balik atau kredit untuk tempoh langganan tahunan separa.
		</p>
		<h3>6. HARGA DAN CUKAI</h3>
		<p>
			Harga produk yang ditawarkan di {siteName} ditunjukkan dalam euro
			(€) atau mata wang negara dari mana pembelian dibuat, Nilai
			Cukai Ditambah (VAT) yang berkuat kuasa pada masa pembelian dikenakan ke atas harga
			produk.
		</p>
		<p>
			Walau apa pun, operasi itu boleh dikecualikan atau tidak tertakluk kepada VAT bergantung pada
			negara tempat tinggal anda atau keadaan di mana anda bertindak. Atas sebab ini,
			dalam beberapa kes harga akhir pesanan boleh diubah berkenaan dengan
			satu ditunjukkan.<br />
			Pembelian yang dibuat oleh subjek yang dikecualikan daripada pembayaran VAT akan menunjukkan perkara ini oleh
			menghantar nombor VAT/NIF mereka melalui e-mel kepada {supportLink}, bukan rakaman
			pembelian dengan cukai tersebut.
		</p>
		<h3>7. KAEDAH PEMBAYARAN</h3>
		<p>
			Pembayaran dalam talian bagi perkhidmatan yang dibeli boleh dibuat dengan kad kredit atau debit.
			Dalam pengertian ini, {siteName} memberitahu pemegang kad kredit dan debit bahawa
			transaksi di kedai dalam talian dijalankan melalui pembayaran yang selamat
			gerbang, menggunakan teknologi SSL untuk menjamin keselamatan penghantaran data.
		</p>
		<h3>8. HAK PENGELUARAN DAN PEMBAYARAN BALIK</h3>
		<h4>8.1. Hak pengeluaran</h4>
		<p>
			Memandangkan jenis produk yang dipasarkan dalam perkhidmatan dalam talian kami, perisian dalam digital
			format QR, hak pengeluaran tidak akan terpakai mengikut
			perkara 103, huruf m) Dekri Perundangan Diraja 1/2007, 16 November, oleh
			bahawa teks semakan Undang-undang Am untuk Pertahanan Pengguna dan
			Pengguna dan undang-undang pelengkap lain diluluskan.
		</p>
		<h4>8.2. Bayaran balik</h4>
		<p>
			Tidak kira pelan yang dipilih oleh pengguna, jumlah yang dibayar oleh pengguna dan kepada
			takat yang dibenarkan oleh undang-undang tidak akan dikembalikan.
		</p>
		<p>
			Perkhidmatan yang dikontrakkan tidak boleh diberikan atau dipindahkan kepada pengguna lain
			Perkhidmatan tersebut.
		</p>
		<p>
			Walau apa pun, pengguna boleh menggunakan perkhidmatan yang dikontrakkan sehingga tamat
			tempoh kontrak.
		</p>
		<h3>9. SAH TAWARAN</h3>
		<p>
			Perkhidmatan yang ditawarkan dalam Perkhidmatan, dan harganya, akan tersedia untuk
			pembelian semasa mereka berada dalam katalog perkhidmatan yang dipaparkan melalui ini
			laman web.
		</p>
		<p>
			Walau apa pun, {siteName} berhak untuk membuat pengubahsuaian itu
			difikirkan sesuai dalam Perkhidmatan, dapat mengemas kini produk dan perkhidmatan
			bergantung pada pasaran.
		</p>
		<p>
			{siteName} berhak untuk menukar harga tanpa notis awal. Kami
			memberitahu anda bahawa walaupun kemas kini yang dibuat kepada harga
			Perkhidmatan, ia mungkin mengandungi ralat. Kami akan segera membetulkan sebarang kesilapan itu
			muncul, tetapi ia tidak akan terikat pada Perkhidmatan.
		</p>
		<h3>10. KESELAMATAN</h3>
		<p>
			Seperti yang dinyatakan di atas, keseluruhan prosedur pembelian, serta penghantaran
			data peribadi anda dan sistem pembayaran, dijalankan pada halaman selamat dan
			dengan cara yang disulitkan melalui protokol SSL.
		</p>
		<p>
			Kami menjamin keselamatan Perkhidmatan mengikut semasa
			pengetahuan teknologi. Walau bagaimanapun, {siteName} tidak dapat menjamin sepenuhnya
			keselamatan masa hadapan Perkhidmatan. Walau apa pun, kami berjanji untuk membetulkan dan
			melaksanakan langkah pembetulan yang sesuai untuk membetulkan keselamatan yang mungkin
			pelanggaran secepat mungkin.
		</p>
		<p>
			Anda bersetuju untuk memberitahu {siteName}, serta-merta dan melalui e-mel {supportLink}
			sebarang situasi yang boleh membawa kepada penyamaran identiti pengguna.
		</p>
		<h3>11. PENGUBAHSUAIAN DAN NULLITI</h3>
		<p>
			Kami mungkin mengemas kini terma dan syarat Perkhidmatan pada masa hadapan juga
			sebagai ciri dan fungsi Perkhidmatan itu sendiri.
		</p>
		<p>
			Kami akan memaklumkan kepada anda tentang perubahan dalam terma dan syarat dengan meletakkan notis
			di tempat yang menonjol di laman web kami dan/atau melalui e-mel.
		</p>
		<p>
			Jika mana-mana klausa yang termasuk dalam terma dan syarat ini diisytiharkan, sama sekali atau
			sebahagiannya, batal atau tidak berkesan, ia hanya akan menjejaskan peruntukan atau bahagian tersebut
			daripadanya yang batal atau tidak berkesan. Terma dan syarat akan wujud dalam
			segala-galanya, mempunyai peruntukan sedemikian, atau sebahagian daripadanya yang terjejas, oleh
			tidak diletakkan.
		</p>
		<h3>12. TUNTUTAN DAN TINDAKAN YANG TERDAPAT DARIPADA KONTRAK</h3>
		<p>
			Seboleh-bolehnya, Perkhidmatan ini dikawal oleh undang-undang Sepanyol.<br />
			Bagi memudahkan penyelesaian tuntutan melalui prosiding sivil dan
			mengurangkan kos, kami tidak mengecualikan kemungkinan menyerahkan diri kami kepada an
			Timbang Tara Ekuiti Mahkamah Timbang Tara Dewan Perniagaan dan
			industri. Dalam pengertian ini, dan menurut peraturan yang berlaku,
			 {siteName} memaklumkan kewujudan penyelesaian pertikaian dalam talian Eropah
			platform yang memudahkan penyelesaian di luar mahkamah pertikaian tersebut untuk
			kontrak juga dibuat dalam talian antara pengguna dan perkhidmatan Internet
			pembekal. Platform ini boleh diakses melalui laman web berikut:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. HAK HARTA INTELEK DAN INDUSTRI</h3>
		<p>
			Laman Web dan kandungannya tertakluk kepada perlindungan dalam penggunaan
			peraturan kebangsaan semasa mengenai Harta Intelek dan/atau Perindustrian, sebagai
			serta dalam pemakaian konvensyen antarabangsa yang terpakai dalam hal tersebut
			perkara. {siteName} ialah pemilik atau telah melesenkan semua
			Hak Harta Intelek dan Perindustrian pada Laman Web dan kandungannya.
		</p>
		<p>
			Sebarang bentuk pembiakan, pengedaran, komunikasi awam, transformasi,
			menyediakan dan, secara amnya, sebarang tindakan eksploitasi lain sama ada atau tidak
			untuk tujuan komersial Laman Web atau kandungannya, tanpa terlebih dahulu
			menyatakan persetujuan {siteName}. Ia dilarang sama sekali untuk memadam
			mengenal pasti data {siteName} sebagai pemilik Intelektual dan
			Hak Harta Perindustrian Laman Web atau kandungannya.
		</p>
		<p>
			{siteName} menyimpan semua hak Harta Intelek dan Perindustrian
			melalui Laman Web dan kandungannya, juga mengkhaskan pelaksanaan mana-mana undang-undang
			tindakan yang sepadan dengannya untuk menghentikan, mencegah atau mendakwa mana-mana
			penggunaan haram Laman Web atau kandungannya. Dalam sebarang kes dan di bawah no
			keadaan tidak mengakses Laman Web atau penggunaannya oleh Pengguna atau ketiga
			pihak membentuk atau membayangkan apa-apa jenis penyerahan hak oleh {siteName} daripada
			hak Harta Intelek atau Perindustrian Laman Web atau kandungannya.
			Walau apa pun kekurangan keperluan oleh {siteName} untuk menghentikan penggunaan
			Laman web atau tidak sah atau kandungannya yang bertentangan dengan syarat ini mungkin
			difahami sebagai persetujuan tersirat oleh {siteName} untuk penggunaan sedemikian atau sebagai penepian
			pelaksanaan sebarang tindakan undang-undang yang mungkin sepadan dengannya.
		</p>
		<h3>14. TANGGUNGJAWAB DAN JAMINAN</h3>
		<p>
			Pengguna mesti menggunakan Laman Web dan kandungannya selaras dengan
			peruntukan syarat penggunaan ini, perundangan semasa dan niat baik. mana-mana
			penggunaan laman web atau kandungannya yang bertentangan dengan syarat am ini, yang
			undang-undang atau niat baik adalah dilarang secara nyata, tidak kira sama ada penggunaan tersebut telah
			tujuan ekonomi atau tidak.<br />
			Pengguna akan bertanggungjawab atas sebarang kerosakan atau bahaya yang disebabkan oleh {siteName}
			 atau kepada pihak ketiga yang diperoleh secara langsung atau tidak langsung daripada sebarang penggunaan
			bahawa Pengguna membuat Laman Web atau kandungannya bertentangan dengan ini
			syarat, undang-undang, moral, ketenteraman awam atau niat baik.
		</p>
		<p>
			Untuk Tapak Web dan kandungannya boleh diakses oleh Pengguna, {siteName}
			 memerlukan perkhidmatan yang disediakan oleh pihak ketiga. berkemungkinan begitu
			walaupun terdapat usaha yang dilakukan oleh {siteName} untuk memastikan Laman Web tersedia
			dan boleh diakses oleh pengguna, ketersediaannya mungkin digantung, terganggu atau
			dibatalkan atas sebab di luar {siteName}. Itulah sebabnya {siteName}
			tidak menjamin ketiadaan gangguan atau ralat dalam mengakses
			Laman web atau kandungannya, mahupun ia dikemas kini atau sentiasa dipaparkan di dalamnya
			versi terbaru mereka. Akibatnya, {siteName} menolak sebarang
			tanggungjawab untuk kerosakan yang mungkin diperoleh kepada Pengguna atau pihak ketiga sebagai
			akibat daripada penggantungan, gangguan, kekurangan kesinambungan, gangguan rangkaian
			atau pemutusan sambungan Laman Web.
		</p>
		<p>
			Walau apa pun dan dalam apa jua keadaan, {siteName} tidak akan bertanggungjawab
			kerosakan atau kerugian yang diperoleh pengguna daripada sebab yang tidak dikaitkan dengan {siteName}
			 seperti, melalui teladan dan tidak mengehadkan, semula jadi
			bencana, situasi force majeure atau kecemasan yang melampau, virus, berbahaya
			komponen, kerosakan pelayar, kejatuhan rangkaian, pencerobohan komputer atau
			serangan pihak ketiga.
		</p>
		<h3>15. PAUTAN</h3>
		<p>
			Laman web, platform, forum, sembang, blog atau rangkaian sosial luaran yang
			pautan atau pautan ke Laman Web mesti memaklumkan dengan jelas bahawa mereka tidak mempunyai
			kebenaran atau penyeliaan {siteName} dan yang dikatakan memautkan atau
			pautan tidak melibatkan, mengandaikan atau membayangkan perkaitan dalam apa jua bentuk antara {siteName}
			 dan tapak web, platform, forum, sembang, blog atau luaran
			rangkaian sosial yang memaut atau memaut ke Laman Web.
		</p>
		<p>
			Walau apa pun, sebarang pautan yang ditujukan untuk Laman Web mesti diarahkan
			terus ke halaman utama atau halaman utama Laman Web dengan mengklik pada URL
			laman web yang meliputi keseluruhan skrin halaman utama atau halaman permulaan
			Laman Web, supaya pautan adalah mutlak dan lengkap tanpa menggunakan
			bingkai, bingkai atau hiperpautan. {siteName} tidak bertindak balas dalam apa jua keadaan
			dan dalam apa jua keadaan kepada kandungan, maklumat atau data yang berkaitan dengan
			laman web, kandungannya atau apa-apa perkara lain yang terkandung dalam laman web, platform,
			forum, sembang, blog atau rangkaian sosial pihak ketiga yang memaut atau memaut ke
			laman web.
		</p>
		<p>
			Dilarang nyata untuk memaut atau memaut ke Laman Web daripada laman web,
			platform, forum, sembang, blog atau rangkaian sosial yang bertentangan dengan undang-undang, moral
			dan adat yang baik, terutamanya yang mempunyai lucah, haram, haram atau
			kandungan yang melanggar hak asasi manusia.
		</p>
		<p>
			Sebaliknya, Laman Web mungkin mengandungi pautan ke laman web pihak ketiga,
			platform, forum, sembang, blog atau rangkaian sosial. {siteName} tidak
			mempunyai cara manusia dan/atau teknikal untuk mengetahui atau mengawal maklumat dan
			kandungan yang muncul di tapak web pihak ketiga. Oleh itu, {siteName} tidak akan
			 bertanggungjawab ke atas kandungan tapak yang dipautkan dan di bawah no
			keadaan boleh dikatakan pautan dianggap sebagai pengetahuan berkesan tentang kandungan
			tapak yang mereka pautkan.
		</p>
		<h3>16. PERLINDUNGAN DATA</h3>
		<p>
			Seperti yang ditetapkan dalam {privacyPolicyLink}nya, {siteName} mengaku janji untuk menggunakan Pengguna
			data, untuk menghormati kerahsiaannya dan menggunakannya selaras dengan
			tujuan rawatan, serta mematuhi kewajipannya untuk menyelamatkannya.
			dan menyesuaikan semua langkah untuk mengelakkan perubahan, kehilangan, rawatan atau tanpa kebenaran
			akses selaras dengan peruntukan undang-undang semasa mengenai
			perlindungan data peribadi.
		</p>
		<p>
			Laman web ini menggabungkan perlindungan yang sesuai dan menggunakan standard industri
			teknologi untuk meningkatkan keselamatan, integriti, kesempurnaan, ketepatan dan
			perlindungan data peribadi yang telah dikumpulkannya, dan telah ditubuhkan
			langkah berjaga-jaga yang munasabah untuk melindungi maklumat tersebut daripada kemungkinan kehilangan atau
			salah guna. Peraturannya mengenai perlindungan dan keselamatan data disemak secara berkala
			dan ditambah baik apabila perlu, dan ia berusaha untuk memastikan bahawa hanya dibenarkan
			orang boleh mengakses maklumat yang diberikan oleh Pengguna.
		</p>
		<p>
			Untuk mengetahui lebih lanjut tentang pengurusan dan rawatan yang dijalankan oleh {siteName}
			 data anda, sila baca {privacyPolicyLink} kami dan {cookiesPolicyLink} kami.
		</p>
		<h3>17. TEMPOH DAN PENGUBAHSUAIAN</h3>
		<p>
			Syarat penggunaan ini akan berkuat kuasa selagi ia terdedah
			pengguna, supaya sebaik sahaja mereka diubah suai atau dikemas kini sepenuhnya atau sebahagiannya,
			syarat-syarat ini akan berhenti berkuat kuasa, sebagai syarat penggunaan baharu
			mereka yang seterusnya mengawal selia penggunaan Laman Web.
		</p>
		<p>
			{siteName} berhak untuk menyemak, mengubah suai atau mengemas kini perkara ini
			syarat penggunaan pada bila-bila masa. Sekiranya berlaku sebarang perubahan dalam keadaan ini
			penggunaan atas sebarang sebab, {siteName} akan memberitahu pengguna di halaman utama tentang
			web tentang keadaan tersebut supaya mereka dimaklumkan dengan sewajarnya dan boleh berunding
			semakan, pengubahsuaian atau kemas kini keadaan penggunaan sekarang untuk
			kepuasan anda.
		</p>
		<h3>18. AM</h3>
		<p>
			Dalam apa jua keadaan dan dalam apa jua keadaan mungkin kekurangan pelaksanaan hak anda
			oleh {siteName} difahami sebagai penepian daripada mereka.
		</p>
		<p>
			Tajuk yang terkandung dalam syarat ini hanyalah petunjuk atau
			bermaklumat, supaya mereka tidak menjejaskan, melayakkan atau mengembangkan tafsiran
			daripadanya.
		</p>
		<p>
			Sekiranya mana-mana klausa yang terkandung dalam syarat ini adalah
			diisytiharkan batal, menyalahgunakan atau tidak boleh dikuatkuasakan, sepenuhnya atau sebahagiannya, oleh badan kehakiman
			atau badan pentadbiran, pengisytiharan tersebut akan mempengaruhi klausa secara individu
			berkenaan, mengambilnya sebagai tidak dan tanpa pengisytiharan batal, penyalahgunaan atau
			ketidakbolehgunaan dilanjutkan dalam apa jua keadaan kepada seluruh
			syarat, yang akan wujud.
		</p>
		<p>
			Syarat penggunaan ini, serta {privacyPolicyLink} dan {cookiesPolicyLink}
			dikawal oleh peraturan semasa Sepanyol pada setiap masa.
		</p>
		<h3>19. PERKHIDMATAN PELANGGAN</h3>
		<p>
			Untuk sebarang penjelasan, insiden atau tuntutan, anda boleh menghubungi kami melalui:<br />
			E-mel: {supportLink}<br />
			Alamat pos: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Sepanyol.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Kemas kini terakhir: 10 Jun 2024',
		content: `
			<h3>1. Pihak yang bertanggungjawab dan penerangan</h3>
			<h5>1.1. Bertanggungjawab</h5>
			<p>Orang yang bertanggungjawab untuk rawatan tapak ini ialah Alih Keluar Latar Belakang S.L (selepas ini Alih Keluar Latar Belakang 
			atau Perkhidmatan), dengan alamat di Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Sepanyol.</p>
			<p>NIF: B56768260<br> E-mel: {supportLink}</p>

			<h5>1.2. Penerangan</h5>
			<p>Penerimaan dasar privasi Buang Latar Belakang (selepas ini "Dasar Privasi"), adalah syarat yang perlu 
				untuk penggunaan laman web kami dan penyediaan perkhidmatan (selepas ini "Perkhidmatan").<br>
				Dasar Privasi ini mengawal selia pengumpulan, rawatan dan penggunaan maklumat peribadi dan bukan peribadi anda 
				sebagai pengguna Alih Keluar Latar Belakang, pada tarikh kuat kuasa yang muncul dalam pengepala.<br>
				Untuk memproses data peribadi anda, Buang Latar Belakang mematuhi undang-undang tempatan dan Eropah semasa, 
				serta peraturan pelaksanaannya.</p>


			<h3>2. Maklumat dikumpul</h3>
			<p>Akses ke laman web kami boleh dilakukan tanpa perlu memberikan sebarang maklumat, walaupun untuk mendaftar dan / 
				atau kontrak rancangan kami, anda perlu memberikan kami beberapa maklumat peribadi. Maklumat (peribadi 
				atau bukan peribadi) yang dikumpulkan oleh Perkhidmatan mungkin berbeza-beza berdasarkan itu.<br>
				Maklumat peribadi dan bukan peribadi yang dikumpul oleh Perkhidmatan akan datang kepada kami dalam tiga cara: 1) yang 
				dikumpulkan secara automatik 2) yang anda berikan kepada kami secara sukarela dan 3) yang disediakan oleh pihak ketiga.</p>

			<h5>2.1. Yang dikumpul secara automatik</h5>
			<p>Maklumat ini terdiri daripada:</p>
			<ul>
				<li>Yang dikumpul melalui kuki atau mekanisme serupa yang disimpan pada peranti anda, sentiasa dengan persetujuan anda atau masuk 
					selaras dengan asas undang-undang lain. Semak Dasar Kuki kami untuk mendapatkan maklumat lanjut.</li>
				<li>IP dari mana sambungan dibuat, jenis peranti yang digunakan dan ciri-cirinya, versi 
					sistem pengendalian, jenis penyemak imbas, bahasa, tarikh, negara, masa permintaan, 
					URL daripada tempat asal anda, URL yang anda pergi atau rangkaian mudah alih yang digunakan, antara lain.</li>
				<li>Data penggunaan perkhidmatan dan kemungkinan ralat dikesan semasa penggunaannya.</li>
				<li>Selain itu, Alih Keluar Latar Belakang menggunakan Analitis Google, perkhidmatan analisis yang disediakan oleh Google, LLC. 
					berdomisil di Amerika Syarikat dengan ibu pejabat di 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					Untuk penyediaan perkhidmatan ini, mereka menggunakan kuki yang mengumpul maklumat, termasuk alamat IP pengguna, 
					yang akan dihantar, diproses dan disimpan oleh Google dalam syarat yang ditetapkan di web www.google.com. 
					Termasuk kemungkinan penghantaran maklumat tersebut kepada pihak ketiga atas sebab keperluan undang-undang atau 
					apabila pihak ketiga tersebut memproses maklumat bagi pihak Google.</li>
			</ul>
			<p>Dalam apa jua keadaan, anda boleh melumpuhkan kuki Google Analitis daripada <a href="{externalLink: disableGoogleAnalyticsLink}">di sini</a>.</p>

			<h5>2.2. Yang anda sediakan secara sukarela</h5>
			<p>Maklumat ini terdiri daripada:</p>
			<ul>
				<li>Semua data adalah wajib.</li>
				<li>Yang diperlukan oleh Alih Keluar Latar Belakang untuk melengkapkan pendaftaran anda di web: nama dan nama keluarga, alamat dan e-mel, antara lain.</li>
				<li>Semua data adalah wajib.</li>
				<li>Maklumat, peribadi atau tidak, untuk melengkapkan kontrak perkhidmatan seperti alamat e-mel anda dan nombor kad kredit atau debit anda.</li>
				<li>Maklumat, peribadi atau tidak, bahawa mesej yang dihantar melalui hubungan atau saluran pendapat yang ditubuhkan dalam Perkhidmatan mungkin mengandungi, 
					contohnya nama dan e-mel anda.</li>
			</ul>

			<h5>2.3. Yang disediakan oleh pihak ketiga</h5>
			<p>Maklumat ini terdiri daripada:</p>
			<ul>
				<li>Yang disediakan oleh sistem pembayaran atau pemproses kad kredit, seperti masa pembelian atau jumlahnya.</li>
			</ul>


			<h3>3. Hak dan tujuan</h3>
			<p>Kami memaklumkan anda bahawa pengisian borang adalah secara sukarela. Namun, jika anda tidak mengisi ruangan yang diperlukan 
				(biasanya ditandakan dengan asterisk), penggunaan beberapa fungsi Perkhidmatan tidak akan dapat dilakukan atau akan dihadkan.<br>
				Data peribadi yang anda berikan kepada kami akan dimasukkan dan diproses dalam Pendaftaran Aktiviti Rawatan Alih Latar Belakang 
				untuk dapat memenuhi permintaan anda, menyediakan perkhidmatan yang diminta dan memaklumkan anda tentang perkara yang berkaitan dengan aktiviti 
				syarikat dan perkhidmatannya.<br>
				Anda boleh melaksanakan pada bila-bila masa hak akses, pembetulan, pemadaman, pengehadan rawatan anda, 
				penentangan dan mudah alih data peribadi anda melalui e-mel yang dialamatkan kepada: {supportLink} atau alamat pos: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Sepanyol.<br>
				Dalam kedua-dua kes, anda mesti mengenal pasti diri anda dengan nama dan nama keluarga anda, serta salinan DNI atau ID kebangsaan anda, jika perlu.<br>
				Sekiranya anda telah memberikan persetujuan untuk tujuan tertentu, anda mempunyai hak untuk menarik balik kebenaran pada bila-bila masa, 
				tanpa menjejaskan kesahihan rawatan berdasarkan persetujuan sebelum penarikannya.<br>
				Selain itu, jika anda menganggap bahawa terdapat masalah dengan cara Buang Latar Belakang mengendalikan data anda, 
				anda boleh mengarahkan aduan anda kepada <a href="{knowYourRightsLink}">pihak berkuasa perlindungan data</a> yang sepadan, sebagai <a href="{aepdLink}">Agensi Sepanyol untuk Perlindungan Data</a> 
				yang ditunjukkan dalam kes Sepanyol.</p>


			<h3>4. Umur</h3>
			<p>Mengenai penggunaan perkhidmatan dalam talian, anda mengisytiharkan bahawa anda telah mencapai umur yang sah dan anda mempunyai undang-undang yang diperlukan 
				kapasiti untuk terikat dengan perjanjian ini dan menggunakan tapak selaras dengan terma dan syaratnya, yang anda sepenuhnya 
				faham dan akui.<br>
				Anda mengisytiharkan bahawa semua maklumat yang anda berikan untuk mengakses Perkhidmatan, sebelum dan semasa penggunaannya, adalah benar, lengkap 
				dan tepat.</p>


			<h3>5. Penggunaan data</h3>
			<p>Alih Keluar Latar Belakang akan menggunakan data yang dikumpul untuk:</p>
			<ul>
				<li>Urus dan kemas kini Perkhidmatan (asas undang-undang adalah kepentingan sah kami dalam mengekalkan dan mengekalkan Perkhidmatan 
					terkini dan dalam keadaan baik).</li>
				<li>Tuntaskan soalan yang anda bangkitkan (asas undang-undang adalah kepentingan sah kami untuk memenuhi permintaan dan 
					keraguan pengguna kami).</li>
				<li>Proses pembayaran yang anda buat (kontrak menjadi asas undang-undang).</li>
				<li>Sediakan perkhidmatan yang dikontrakkan (kontrak menjadi asas undang-undang).</li>
				<li>Kekalkan keselamatan Perkhidmatan, siasat aktiviti yang menyalahi undang-undang, kuatkuasakan terma dan syarat kami dan
					membantu pasukan keselamatan negeri dalam rangka penyiasatan mereka yang mungkin (asas undang-undang adalah kami 
					kepentingan yang sah dalam menjamin dan mengekalkan keselamatan Perkhidmatan dan penggunanya).</li>
			</ul>
			<p>Alih Keluar Latar Belakang tidak menggunakan keputusan automatik, walaupun ia boleh menjana profil pengguna asas, 
				asas undang-undang ialah kepentingan sah kami untuk tujuan komersial dan menyediakan tawaran yang diperibadikan.<br>
				Selain itu, Alih Keluar Latar Belakang boleh menggunakan maklumat pengguna dalam bentuk data agregat dan tanpa nama untuk menunjukkannya kepada pihak ketiga. 
				Anda juga boleh berkongsi statistik dan maklumat demografi tentang pengguna dan penggunaan Perkhidmatan mereka dengan pihak ketiga. 
				Tetapi semua ini tidak akan membenarkan pihak ketiga tersebut mengenal pasti anda secara peribadi.</p>

			<h5>5.1. Dalam e-mel dan borang hubungan</h5>
			<p>Tapak web ini mempunyai penyulitan SSL yang membolehkan pengguna menghantar data peribadi mereka dengan selamat melalui borang hubungan standard.<br>
				Data peribadi yang dikumpul akan tertakluk kepada pemprosesan automatik dan dimasukkan ke dalam fail yang sepadan 
				rekod aktiviti pemprosesan dan yang mana Alih Keluar Latar Belakang adalah pemiliknya.</p>
			<p>Dalam pengertian itu:</p>
			<ul>
				<li>Kami akan menerima alamat IP anda, yang akan digunakan untuk mengesahkan asal mesej untuk menawarkan anda 
					cadangan (contohnya, kemukakan maklumat dalam bahasa yang betul) dan untuk mengesan kemungkinan penyelewengan 
					(contohnya, kemungkinan percubaan untuk menyerang siber Perkhidmatan), serta data yang berkaitan dengan ISP anda.</li>
				<li>Begitu juga, anda boleh memberikan kami data anda melalui telefon, e-mel dan cara komunikasi lain yang dinyatakan.</li>
			</ul>
			<p>Mengenai cara pembayaran yang digunakan:</p>
			<ul>
				<li>Pembekal perkhidmatan pembayaran kami untuk membayar penyediaan perkhidmatan kami ialah kad kredit atau debit. 
					Perkhidmatan atau kakitangannya tidak akan mempunyai akses kepada butiran bank pada bila-bila masa (contohnya, nombor kad kredit) 
					yang pengguna sebagai pelanggan akan berikan kepada pihak ketiga tersebut.</li>
			</ul>


			<h3>6. Pengekalan data</h3>
			<p>Di bawah, ia ditunjukkan untuk tempoh data yang diproses oleh Perkhidmatan disimpan:</p>
			<ul>
				<li>Data yang diasingkan akan disimpan tanpa tempoh pemadaman.</li>
				<li>
					Data pelanggan akan disimpan pada tahap minimum yang diperlukan, dan boleh disimpan sehingga:
					<ul>
						<li>5 tahun, mengikut seni. 1964 Kanun Sivil (tindakan peribadi tanpa istilah khas).</li>
						<li>6 tahun, mengikut seni. 30 Kod Komersial (contohnya buku perakaunan atau invois).</li>
					</ul>
				</li>
				<li>Data pengguna akan disimpan untuk tempoh maksimum 12 bulan untuk dapat memenuhi permintaan mereka.</li>
			</ul>


			<h3>7. Data dikongsi dengan pihak ketiga</h3>
			<p>Terdapat pihak ketiga yang menguruskan sebahagian daripada Perkhidmatan.<br>
				Alih Keluar Latar Belakang memerlukan mereka untuk mematuhi Dasar Privasi ini sebagaimana yang berkenaan, di samping memilikinya sendiri. Walau bagaimanapun, Alih Keluar Latar Belakang tidak akan bertanggungjawab untuk pematuhan dasar tersebut.<br>
				Dalam keadaan tertentu, Alih Keluar Latar Belakang boleh berkongsi, menggunakan atau menyimpan dengan pihak ketiga mana-mana maklumat peribadi yang dikumpul:</p>
			<ul>
				<li>Untuk menyediakan Perkhidmatan:</li>
			</ul>
			<p>Pembekal perkhidmatan yang melaksanakan fungsi bagi pihak kami, seperti perkhidmatan pembayaran, pengehosan web, analitik perniagaan, perkhidmatan pelanggan atau pemasaran web. Pembekal perkhidmatan ini mungkin mengumpul dan mempunyai akses kepada maklumat yang diperlukan untuk mereka melaksanakan fungsi mereka, tetapi mereka tidak dibenarkan berkongsi atau menggunakan maklumat itu untuk sebarang tujuan lain.</p>
			<ul>
				<li>Untuk bekerjasama dengan pihak berkuasa yang berwibawa:</li>
			</ul>
			<p>Jika kami percaya adalah perlu untuk memenuhi mana-mana undang-undang, proses undang-undang atau kepentingan yang sah. Walau apa pun, kami hanya akan memberikan maklumat yang diperlukan.</p>


			<h3>8. Langkah keselamatan</h3>
			<p>Alih Keluar Latar Belakang menerima pakai semua langkah teknikal dan organisasi yang diperlukan untuk
				melindungi keselamatan dan integriti maklumat peribadi dan bukan peribadi yang dikumpul. 
				Kedua-duanya terhadap akses tanpa kebenaran dan pengubahan, kehilangan atau kemusnahan secara tidak sengaja.<br>
				Walau apa pun, Buang Latar Belakang tidak dapat menjamin keselamatan mutlak maklumat yang dikumpul, 
				jadi anda mesti bekerjasama dan menggunakan akal fikiran tentang maklumat yang dikongsi pada setiap masa.<br>
				Anda memahami dan mengakui bahawa, walaupun selepas pemadaman, maklumat peribadi dan bukan peribadi mungkin 
				kekal kelihatan dalam cache atau jika pengguna lain telah menyalin atau menyimpannya.</p>


			<h3>9. Perubahan pada Dasar Privasi</h3>
			<p>Kami mungkin mengemas kini Dasar Privasi ini pada masa hadapan. Kami akan memaklumkan kepada anda tentang perubahannya dengan menghantar notis ke alamat e-mel yang diberikan dan/atau dengan meletakkan notis di tempat yang menonjol di tapak web kami.</p>


			<h3>10. Kenalan</h3>
			<p>Jika anda mempunyai soalan tentang Dasar Privasi ini, hubungi kami di:</p>
			<p>E-mel: {supportLink}<br> 
				Alamat: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Sepanyol.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Kemas kini terakhir: 10 Jun 2024',
		content: `
			<h3>1. Siapa yang bertanggungjawab dan bagaimana untuk menghubungi mereka?</h3>
			<p>Pengawal tapak ini ialah Alih Keluar Latar Belakang S.L dengan alamat di Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Sepanyol.</p>
			<p>Anda boleh menghubunginya melalui e-mel di {supportLink}.</p>

			<h3>2. Apakah data yang dikumpul?</h3>
			<p>
				Kami mengumpul data secara automatik melalui kuki yang kami muatkan pada peranti anda, termasuk analitis. 
				Kami juga mengumpul IP dari mana sambungan dibuat, jenis peranti yang digunakan dan ciri-cirinya, 
				versi sistem pengendalian, jenis penyemak imbas, bahasa, tarikh, negara, masa permintaan, 
				URL dari mana anda berasal, URL yang anda pergi atau rangkaian mudah alih yang digunakan, antara lain.<br>
				Secara sukarela pengguna memberikan kami beberapa maklumat seperti nama dan nama keluarga, e-mel atau maklumat banknya 
				untuk dapat menghubungi kami, mendaftar untuk perkhidmatan atau membeli langganan.
			</p>

			<h3>3. Data yang dikumpul digunakan untuk apa?</h3>
			<p>
				Perkhidmatan akan menggunakan data yang dikumpul, antara lain, untuk mentadbir dan mengemas kini perkhidmatan, membalas permintaan anda, 
				menghantar surat berita dan tawaran promosi kami kepada anda melalui e-mel, mengurus pendaftaran anda di platform, mengurus dan menyediakan 
				perkhidmatan yang berkaitan dengan langganan anda, memproses pembayaran yang anda buat dan mengeluarkan invois yang sepadan, 
				mengekalkan keselamatan Perkhidmatan, menyiasat aktiviti haram, menguatkuasakan terma dan syarat kami dan 
				membantu pasukan dan badan keselamatan negeri dalam rangka siasatan akhirnya mereka.
			</p>

			<h3>4. Berapa lama ia disimpan?</h3>
			<ul>
				<li>Data yang diasingkan akan disimpan tanpa tempoh pemadaman.</li>
				<li>
					Data pelanggan akan disimpan pada tahap minimum yang diperlukan, dan boleh disimpan sehingga:
					<ul>
						<li>5 tahun, mengikut seni. 1964 Kanun Sivil (tindakan peribadi tanpa istilah khas).</li>
						<li>6 tahun, mengikut seni. 30 Kod Komersial (contohnya buku perakaunan atau invois).</li>
					</ul>
				</li>
				<li>Data pengguna akan disimpan untuk tempoh maksimum 12 bulan untuk memenuhi permintaan mereka.</li>
				<li>Data pengguna yang dimuat naik oleh Perkhidmatan ke halaman dan profil di rangkaian sosial akan disimpan dari saat pengguna menawarkan persetujuannya sehingga dia menarik baliknya.</li>
			</ul>

			<h3>5. Apakah hak anda sebagai pengguna?</h3>

			<p>
				Hak akses: Pihak yang terlibat mempunyai hak untuk mendapatkan pengesahan daripada pengawal data sama ada 
				atau tidak data peribadi mengenainya sedang diproses.
			</p>
			<p>
				Hak pembetulan: pihak yang terjejas mempunyai hak untuk mendapatkan, tanpa kelewatan yang tidak wajar, daripada pengawal data 
				pembetulan data peribadi yang tidak tepat dan yang menjejaskannya secara langsung. Begitu juga pihak yang berminat akan 
				mempunyai hak untuk melengkapkan data peribadi yang tidak lengkap, termasuk melalui pengisytiharan tambahan.
			</p>
			<p>
				Hak pemadaman: Ia adalah hak pihak yang terjejas untuk mendapatkan, tanpa kelewatan yang tidak wajar, daripada pengawal data pemadaman 
				data peribadi yang berkaitan dengannya.
			</p>
			<p>
				Hak untuk mengehadkan pemprosesan data: terdiri daripada mendapatkan had pemprosesan data anda oleh orang yang bertanggungjawab, 
				walaupun penggunaannya mempunyai dua aspek: 1) Apabila anda mencabar ketepatan data peribadi anda, dalam tempoh yang membenarkan 
				orang yang bertanggungjawab untuk mengesahkannya dan 2) Apabila anda telah membantah pemprosesan data peribadi anda bahawa orang yang bertanggungjawab 
				dijalankan berdasarkan kepentingan sah atau misi kepentingan awam, manakala orang yang bertanggungjawab mengesahkan sama ada sebab-sebab ini 
				mengatasi anda.
			</p>
			<p>
				Hak untuk mudah alih data: Ia adalah hak pihak yang terjejas untuk menerima data peribadi yang berkaitan dengannya, 
				bahawa dia telah berikan kepada pengawal data, dalam format berstruktur, kegunaan biasa dan bacaan mekanikal, dan 
				untuk menghantarnya kepada pengawal lain tanpa dihalang oleh pengawal yang diberikan kepadanya.
			</p>
			<p>
				Dalam pengertian ini, pihak yang berminat akan mempunyai hak untuk menghantar data peribadi secara langsung daripada pengawal 
				kepada pengawal apabila mungkin secara teknikal.
			</p>

			
			<h3>6. Bagaimanakah anda boleh menggunakan hak anda?</h3>

			<p>
				Anda boleh menggunakan hak data peribadi anda pada bila-bila masa dengan menghantar e-mel ke: {supportLink} Atau alamat pos: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Sepanyol. Dalam kedua-dua kes, anda mesti mengenal pasti diri anda dengan nama dan nama keluarga anda, 
				serta salinan DNI atau ID kebangsaan anda, jika perlu.<br>
				Selain itu, jika anda menganggap bahawa terdapat masalah dengan cara Buang Latar Belakang mengendalikan data anda, anda boleh mengarahkan tuntutan anda 
				kepada <a href="{knowYourRightsLink}">pihak berkuasa perlindungan data</a> yang sepadan, menjadi <a href="{aepdLink}">Agensi Sepanyol untuk Perlindungan Data</a> 
				yang ditunjukkan dalam kes Sepanyol.
			</p>

			<h3>7. Adakah langkah keselamatan diterima pakai?</h3>
			<p>
				Perkhidmatan mengambil semua langkah teknikal dan organisasi yang diperlukan untuk melindungi keselamatan dan integriti peribadi 
				dan maklumat bukan peribadi yang dikumpul. Kedua-duanya terhadap akses tanpa kebenaran dan pengubahan, kehilangan atau kemusnahan secara tidak sengaja.<br>
				Walau apa pun, Perkhidmatan tidak dapat menjamin keselamatan mutlak maklumat yang dikumpul, jadi anda mesti bekerjasama dan 
				gunakan akal pada setiap masa mengenai maklumat yang dikongsi.<br>
				Anda memahami dan mengakui bahawa, walaupun selepas pemadaman, Maklumat Peribadi dan Bukan Peribadi mungkin kekal boleh dilihat dalam cache atau 
				jika disalin atau disimpan oleh pengguna lain.
			</p>

			<h3>8. Adakah terdapat pemindahan data peribadi atau pemindahan antarabangsa?</h3>

			<p>
				Kami tidak memindahkan data atau pemindahan antarabangsa. Walau bagaimanapun, terdapat pihak ketiga yang menguruskan sebahagian daripada Perkhidmatan 
				bahawa kami perlu mematuhi Dasar Privasi kami setakat mana ia terpakai kepada mereka dan mereka mempunyainya sendiri. 
				Pihak ketiga ini adalah penyedia perkhidmatan yang melaksanakan fungsi bagi pihak kami, seperti pengehosan web, 
				pemantauan analitik, atau pembangunan web.<br>
				Juga, jika kami percaya bahawa adalah wajar untuk memenuhi mana-mana undang-undang, proses undang-undang atau kepentingan yang sah. 
				Walau apa pun, kami hanya akan memberikan maklumat yang diperlukan.
			</p>

		`
	},
	cookiesPolicy: {
		lastUpdate: 'Kemas kini terakhir: 21 Jun 2024',
		content: `
			<h3>Ringkasan</h3>
			<ul>
			    <li>Kuki yang digunakan: <strong>Milik dan Pihak Ketiga</strong></li>
			    <li>Adakah ia digunakan untuk mendapatkan statistik? <strong>Ya, berdasarkan minat sah kami dalam mengurus perkhidmatan dengan lebih baik.</strong></li>
			    <li>Perkhidmatan pihak ketiga yang memasang kuki melalui tapak web ini: <strong>Google, Google Analitis, Cloudflare dan Stripe.</strong></li>
			</ul>

			<h3>Cara mengkonfigurasi dan melumpuhkan kuki</h3>
			<p>
			    Anda boleh membenarkan, menyekat atau memadam kuki yang dipasang pada peranti anda daripada penyemak imbas web anda. Jika anda tidak membenarkan kuki dipasang pada peranti anda, 
			    pengalaman menyemak imbas mungkin bertambah buruk. Di bawah, anda boleh menemui cara mengkonfigurasi kuki dalam setiap penyemak imbas:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Jenis dan Kegunaan</h3>
			<p>Perkhidmatan menggunakan kuki sendiri dan kuki pihak ketiga untuk meningkatkan penyemakan imbas, menyediakan perkhidmatan dan mendapatkan statistik tentang penggunaan tapak web.</p>

			<h3>2. Apakah itu kuki dan untuk apa ia digunakan?</h3>
			<p>
			    Kuki ialah fail teks yang dihantar ke pelayar web komputer, mudah alih atau tablet anda dan digunakan untuk menyimpan dan mendapatkan maklumat tentang
			    pelayaran selesai. Contohnya, untuk mengingati nama pengguna dan kata laluan anda atau pilihan profil anda.
			</p>

			<h3>3. Apakah jenis kuki yang ada?</h3>
			<p>Menurut siapa yang menguruskannya:</p>
			<ul>
			    <li>Kuki sendiri; ia dihantar ke penyemak imbas anda daripada peralatan atau domain web kami sendiri.</li>
			    <li>Kuki pihak ketiga; ia dihantar ke penyemak imbas anda daripada peralatan atau domain web yang tidak kami uruskan secara langsung, tetapi oleh entiti ketiga seperti Google.</li>
			</ul>
			<p>Berdasarkan tempoh mereka kekal aktif, terdapat:</p>
			<ul>
			    <li>Kuki sesi; ia kekal dalam fail kuki penyemak imbas anda sehingga anda meninggalkan tapak web, jadi tiada satu pun kekal pada peranti anda.</li>
			    <li>Kuki berterusan; ia kekal pada peranti anda dan tapak web kami membacanya setiap kali anda membuat lawatan baharu. Kuki ini berhenti berfungsi selepas tarikh tertentu.</li>
			</ul>
			<p>Akhir sekali, mengikut tujuan mereka, kami mempunyai:</p>
			<ul>
			    <li>Kuki teknikal; mereka meningkatkan penyemakan imbas dan berfungsi dengan betul tapak web.</li>
			    <li>Kuki pemperibadian; mereka membenarkan akses kepada perkhidmatan dengan ciri yang dipratentukan berdasarkan satu siri kriteria.</li>
			    <li>Kuki analisis; mereka membenarkan mengukur dan menganalisis secara statistik penggunaan perkhidmatan yang disediakan.</li>
			</ul>
			<p>Senarai kuki pihak ketiga yang digunakan oleh <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Kuki mereka (NID atau CONSENT) membenarkan memperibadikan cara iklan muncul di luar Google atau menyimpan maklumat
			        seperti bahasa pilihan apabila memaparkan hasil carian.<br><a href="{externalLink: googleCookieTypes}">Maklumat lanjut</a> tentang jenis kuki yang digunakan oleh Google dalam pelbagai perkhidmatannya.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analitis</a>: Kuki mereka (seperti _ga) membolehkan mengira berapa kali pengguna melawat tapak web, bagaimana, bila dan dari mana.<br>
			        Walau apa pun, anda boleh melumpuhkan kuki Google Analitis daripada <a href="{externalLink: disableGoogleAnalytics}">di sini</a>.
			    </li>
			    <li>Cloudflare: Untuk mengetahui tentang dasar dan penggunaan kuki Cloudflare, klik <a href="{externalLink: cloudflareCookiesPolicy}">pautan ini</a>.</li>
			    <li>Stripe: Cari maklumat <a href="{externalLink: stripeCookiesPolicy}">di sini</a> tentang dasar dan penggunaan kuki Stripe.</li>
			</ul>
		`
	}
};
